import { yup } from "@utils/validation";

export const PasswordFormValidationSchema = yup.object().shape({
  password: yup.string().trim().required(),
});
